import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  computed,
  inject,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Pwa } from '@qtek/libs/app-component';
import { AuthUserStore } from '@qtek/libs/auth-user';
import { DocumentsStore, UserStore } from '@qtek/libs/store';
import {
  DocumentType,
  EXTERNAL_LINKS,
  HTTP_BASE_URL,
} from '@qtek/shared/models';

@Component({
  selector: 'qt-avatar-menu',
  templateUrl: './avatar-menu.component.html',
  styleUrls: ['./avatar-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AvatarMenuComponent implements OnInit {
  private readonly baseUrl = inject(HTTP_BASE_URL);
  pwa = inject(Pwa);
  private readonly documentsStore = inject(DocumentsStore);
  private readonly userStore = inject(UserStore);
  private readonly authUserStore = inject(AuthUserStore);
  private readonly router = inject(Router);

  @Output()
  public framesOpen: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public logoutClicked: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  public personalInfoClicked: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  public sidenav: MatSidenav;

  @Input({ transform: coerceBooleanProperty })
  public isHiddenUserName = false;

  public readonly personalAvatarUrl = computed(() => {
    const docId = this.documentsStore.personalAvatar();
    // Falls back to '' when there's no avatar (e.g. after deletion) so the
    // template shows the placeholder icon instead of keeping the old image.
    return docId ? `${this.baseUrl}/api/v1/service/doc/${docId}` : '';
  });
  public readonly issueReportLink = EXTERNAL_LINKS.ISSUE_REPORT;

  readonly userData = computed(() => {
    const prs = this.userStore.currentPerson();
    const acn = this.userStore.mainCompany();
    const rel = this.userStore.userRelation();
    return {
      name: prs?.name || '',
      company: acn?.name?.name || '',
      email: prs?.email || rel?.email || '',
    };
  });

  ngOnInit(): void {
    this.documentsStore.getEntityDocuments({
      refId: 'prs',
      type: DocumentType.PERSONAL_AVATAR,
    });
  }

  getCompanyName(company: any): string {
    if (!company) {
      return '';
    }

    return company.cmp?.name?.name ? company.cmp.name.name : company.email;
  }

  getCompanyEmail(company: any): string {
    return company.email !== '' ? company.email : '';
  }

  closeSideNave(): void {
    if (this.sidenav && this.sidenav.opened) {
      this.sidenav.close();
    }
  }

  openSettings() {
    this.router.navigate(['stp']);
  }

  public onLogout(): void {
    this.logoutClicked.emit();
  }

  public onFramesOpen(): void {
    this.framesOpen.emit();
  }

  handleLogout(): void {
    this.authUserStore.logout();
  }

  /**
   * Returns false if user first or last name is null or undefined
   *
   * @param {string} name
   * @private
   */
  private validateName(name: string): boolean {
    const trimmedName = name.trim();
    return (
      !trimmedName?.includes('null') && !trimmedName?.includes('undefined')
    );
  }
}
